<template>
  <div class="agent-message-parts">
    <template v-for="(part, idx) in parts" :key="part.id || part.approvalId || idx">
      <div v-if="part.kind === 'text' && part.content" class="part-text" v-html="renderMarkdown(part.content)" />
      <AgentToolCard v-else-if="part.kind === 'tool' && part.tool" :tool="part.tool" />
      <AgentApprovalCard
        v-else-if="part.kind === 'approval'"
        :approval-id="part.approvalId"
        :name="part.name"
        :label="part.label"
        :summary="part.summary"
        :args="part.args"
        :state="part.state || 'pending'"
        @resolved="onApprovalResolved"
      />
    </template>
    <div v-if="streaming && !parts.length" class="typing">
      <span></span><span></span><span></span>
    </div>
  </div>
</template>

<script>
import AgentToolCard from './AgentToolCard.vue'
import AgentApprovalCard from './AgentApprovalCard.vue'

export default {
  name: 'AgentMessageParts',
  components: { AgentToolCard, AgentApprovalCard },
  props: {
    parts: { type: Array, default: () => [] },
    streaming: { type: Boolean, default: false },
  },
  emits: ['approval-resolved'],
  setup(props, { emit }) {
    const renderMarkdown = (text) =>
      String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`(.*?)`/g, '<code>$1</code>')
        .replace(/\n/g, '<br>')

    const onApprovalResolved = (payload) => {
      const part = (props.parts || []).find(
        (p) => p.kind === 'approval' && p.approvalId === payload.approvalId,
      )
      if (part) {
        part.state = payload.approved ? 'approved' : 'rejected'
      }
      emit('approval-resolved', payload)
    }

    return { renderMarkdown, onApprovalResolved }
  },
}
</script>

<style scoped>
.agent-message-parts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.part-text {
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
  white-space: pre-wrap;
}
.part-text :deep(code) {
  background: #f4f4f5;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}
.typing {
  display: flex;
  gap: 4px;
  padding: 8px 0;
}
.typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #409eff;
  animation: bounce 1.2s infinite ease-in-out;
}
.typing span:nth-child(2) {
  animation-delay: 0.15s;
}
.typing span:nth-child(3) {
  animation-delay: 0.3s;
}
@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
